/* eslint-disable i18n-scan/no-inline-content */
import { BodyText, CaptionText, Link } from '@paypalcorp/pp-react'
import PageMessage from 'ppbl/components/PageMessage'
import { trackPage } from 'ppbl/utils/fpti-helper'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import { interpolate } from 'ppbl/utils/string-helper'
import React, { useEffect } from 'react'
import clientLogger from 'ppbl/utils/client-logger'
import { maintenancePageConstants } from 'ppbl/utils/constants'

const HeaderSection = React.lazy(
  () => import('../../components/common/HeaderSection'),
)

const FooterSection = React.lazy(
  () => import('../../components/common/FooterSection'),
)

const fptiData = {
  page: 'maintenancePage',
}

type Props = {
  applicationType: string
}
const MaintenancePage: React.FC<Props> = ({ applicationType }) => {
  useEffect(() => {
    clientLogger.info(
      'Maintanence Page is loaded for the application type:',
      applicationType,
    )
    trackPage(fptiData)
  }, [])

  return (
    <div className="document-body">
      <HeaderSection page="maintenancePage" />
      <PageMessage
        type="maintenance"
        localization={{
          title: getLocalizedText('maintenance-page.title'),
          noteText1: interpolate(
            getLocalizedText('maintenance-page.noteText1.text'),
            {
              phone: (
                <Link
                  href={maintenancePageConstants.phoneNumber.tel}
                  size="sm"
                  secondary
                >
                  {maintenancePageConstants.phoneNumber.phone}
                </Link>
              ),
            },
          ),
          noteText2: interpolate(
            getLocalizedText('maintenance-page.noteText2.text'),
            {
              email: (
                <Link
                  href={maintenancePageConstants.emailAddress.mailto}
                  size="sm"
                  secondary
                >
                  {maintenancePageConstants.emailAddress.email}
                </Link>
              ),
            },
          ),
        }}
      >
        <BodyText className="body__text">
          {getLocalizedText('maintenance-page.bodyText1')}
          <br />
          <br />
          {getLocalizedText('maintenance-page.bodyText2')}
        </BodyText>
        <CaptionText className="caption__text" strong>
          {getLocalizedText('maintenance-page.questionsText')}
        </CaptionText>
      </PageMessage>
      <FooterSection page="maintenancePage" />
    </div>
  )
}

export default MaintenancePage
